$(document).ready(function () {
  
let production_time = $(".personalization-message-lead-time").html();
if (production_time && production_time.includes('{time}')) {
  production_time = production_time.replace("{time}","5 - 7");
  $(".personalization-message-lead-time").html(production_time);
}
  const locations = [
    { id: "63703843013", location: "AU" },
    { id: "75821056253", location: "AU Return Helper" },
    { id: "73893740797", location: "CA" },
    { id: "75821089021", location: "CA Return Helper" },
    { id: "65614119109", location: "DE" },
    { id: "75821187325", location: "DE Return Helper" },
    { id: "75821449469", location: "FR Return Helper" },
    { id: "10906634", location: "GZ" },
    { id: "68242768125", location: "HK Office" },
    { id: "75821285629", location: "HK Return Helper" },
    { id: "73893839101", location: "JP" },
    { id: "75821318397", location: "JP Return Helper" },
    { id: "75821613309", location: "SG Return Helper" },
    { id: "75821678845", location: "TW Return Helper" },
    { id: "63703777477", location: "UK" },
    { id: "75821351165", location: "UK Return Helper" },
    { id: "61210755269", location: "US" },
    { id: "75821383933", location: "US Return Helper" },
    { id: "71068483837", location: "US Shipbob" },
  ];

  const locationMap = {
    AU: "geo_Australia",
    AL: "geo_AllCountry",
    AT: "geo_Germany",
    BY: "geo_Belarus",
    BE: "geo_Germany",
    BA: "geo_AllCountry",
    BG: "geo_Germany",
    CA: "geo_Canada",
    HR: "geo_Germany",
    CY: "geo_Monaco",
    CZ: "geo_Germany",
    DK: "geo_Germany",
    EE: "geo_Germany",
    FO: "geo_AllCountry",
    FI: "geo_Germany",
    FR: "geo_Germany",
    DE: "geo_Germany",
    GR: "geo_Germany",
    GL: "geo_AllCountry",
    HK: "geo_HongKong",
    HU: "geo_Germany",
    IS: "geo_Monaco",
    IE: "geo_Germany",
    IT: "geo_Germany",
    JP: "geo_Japan",
    LV: "geo_Germany",
    LI: "geo_AllCountry",
    LT: "geo_Germany",
    LU: "geo_Germany",
    MY: "geo_AllCountry",
    MT: "geo_Monaco",
    MC: "geo_Monaco",
    NL: "geo_Germany",
    NO: "geo_Monaco",
    PL: "geo_Germany",
    PT: "geo_Germany",
    RO: "geo_Germany",
    CS: "geo_AllCountry",
    SA: "geo_AllCountry",
    SG: "geo_Singapore",
    SK: "geo_Germany",
    SI: "geo_Germany",
    ES: "geo_Germany",
    SE: "geo_Germany",
    CH: "geo_Monaco",
    TW: "geo_Taiwan",
    TH: "geo_AllCountry",
    TR: "geo_Monaco",
    GB: "geo_UK",
    UAE: "geo_AllCountry",
    UA: "geo_AllCountry",
    US: "geo_US",
    VA: "geo_AllCountry",
    VN: "geo_AllCountry",
    REST: "geo_AllCountry",
  };

  const locationIdsMap = {
    geo_Australia: ["63703843013", "75821056253", "10906634"],
    geo_Canada: ["73893740797", "75821089021", "10906634"],
    geo_HongKong: ["75821285629", "10906634"],
    geo_Japan: ["73893839101", "75821318397", "10906634"],
    geo_Singapore: ["75821613309", "10906634"],
    geo_Taiwan: ["75821678845", "10906634"],
    geo_UK: ["63703777477", "75821351165", "10906634"],
    geo_US: ["61210755269", "75821383933", "71068483837", "10906634"],
    geo_AllCountry: ["10906634"],
    geo_Germany: ["65614119109", "75821187325", "75821449469", "10906634"],
    geo_Belarus: ["65614119109", "10906634"],
    geo_Monaco: ["65614119109", "75821187325", "10906634"],
  };

  const getLocationById = id => {
    const loc = locations.find(item => item.id === id);
    return loc ? loc.location : null;
  };           

  const getCountryFlag = countryCode =>
    countryCode.toUpperCase().replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt()));

  const getCookie = name => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    return parts.length === 2 ? parts.pop().split(";").shift() : undefined;
  };

  // Adds N business days to current date
  function addBusinessDays(daysToAdd) {
    let date = new Date();
    if (date.getHours() >= 14) date.setDate(date.getDate() + 1);
    let added = 0;
    while (added < daysToAdd) {
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
      if (added < daysToAdd) date.setDate(date.getDate() + 1);
    }
    return formatDate(date);
  }
  const formatDate = date => {
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  // --- Main estimation logic, for product, grid, and cart ---
  function findEstimateData({
    curvid,
    originLocationIds,
    originCountryName,
    hasengraving,
    isPersonalization
  }) {
    if (!sessionStorage.hasOwnProperty("CurrentInventoryAll")) return null;
    const inv = JSON.parse(sessionStorage.getItem("CurrentInventoryAll"));
    const defaultEl = $('.estimated_shipping_values[data-country="Other"]');
    let mindate = Number(defaultEl.data("min_delivery_days")) + Number(defaultEl.data("processing_days"));
    let maxdate = Number(defaultEl.data("max_delivery_days")) + Number(defaultEl.data("processing_days"));
    let eststr = defaultEl.html();

    const prod = inv.find(p => p.id == curvid);
    if (!prod) return { mindate, maxdate, eststr };

    let foundLocal = false;
    let localWarehouseData = null;
    let gzData = null;

    // Step 1: Try to find local warehouse with inventory
    originLocationIds.forEach(locId => {
      const location = getLocationById(locId);
      
      if (prod[locId] > 0 && location !== "GZ" && hasengraving == 'false') {
        $(".estimated_shipping_values").each(function () {
          const $this = $(this);
          if ($this.data("location") == location && $this.data("country") == originCountryName) {
            const minDel = Number($this.data("min_delivery_days"));
            const maxDel = Number($this.data("max_delivery_days"));
            const processing = Number($this.data("processing_days"));
            const engraving = Number($this.data("engraving_prosessing_time"));

            // Only update once for the first match!
            if (!foundLocal) {
              let curMin = minDel + processing;
              let curMax = maxDel + processing;
              
              if(isPersonalization == true || hasengraving == 'true' ){
                
                curMin = curMin + engraving;
                curMax = curMax + engraving;
              }

              // Personalization message for non-GZ warehouse
               
                let production_time = $(".personalization-message-lead-time").html();
                if (production_time && production_time.includes("5 - 7")) {
                  production_time = production_time.replace(
                    "5 - 7",
                    (engraving - 1) + " - " + (engraving + 1)
                  );
                  $(".personalization-message-lead-time").html(production_time);
                }
               

              mindate = curMin;
              maxdate = curMax;
              eststr = $this.html();
              foundLocal = true;
              localWarehouseData = { mindate, maxdate, eststr };
            }
          }
        });
      }
      // Save GZ warehouse for fallback if needed
      if (prod[locId] > 0 && location === "GZ") {
        $(".estimated_shipping_values").each(function () {
          const $this = $(this);
          if ($this.data("location") == "GZ" && $this.data("country") == originCountryName) {
            const minDel = Number($this.data("min_delivery_days"));
            const maxDel = Number($this.data("max_delivery_days"));
            const processing = Number($this.data("processing_days"));
            const engraving = Number($this.data("engraving_prosessing_time"));

            let curMin = minDel + processing;
            let curMax = maxDel + processing;
            
            if(isPersonalization == true || hasengraving == 'true' || hasengraving == true){
             
              curMin = curMin + engraving;
              curMax = curMax + engraving;
            }

            // Update personalization message for GZ warehouse (engraving)
             
              let production_time = $(".personalization-message").html();
              if (production_time && production_time.includes('{time}')) {
                production_time = production_time.replace(
                  "{time}",
                  (engraving - 1) + " - " + (engraving + 1)
                );
                $(".personalization-message").html(production_time);
              }
             
            gzData = {
              mindate: curMin,
              maxdate: curMax,
              eststr: $this.html()
            };
          }
        });
      }
    });

    // Step 2: Return local warehouse data if found, else fallback to GZ
    if (localWarehouseData) {
      return localWarehouseData;
    } else if (gzData) {
      return gzData;
    } else {
      return { mindate, maxdate, eststr };
    }
  }


  // --- UI updater helpers ---
  function updateGridProduct(curvid, mindate, maxdate) {
    const mindatestr = addBusinessDays(mindate);
    const maxdatestr = addBusinessDays(maxdate);
    $(`.grid__item__product[data-variant-id="${curvid}"]`)
      .find(".custom-product-atc-button")
      .attr("data-estimateddate", `${mindatestr} and ${maxdatestr}`);
  }
  function updateCartItem(curvid, linekey, mindate, maxdate) {
    const mindatestr = addBusinessDays(mindate);
    const maxdatestr = addBusinessDays(maxdate);
    const estimdate = `${mindatestr} and ${maxdatestr}`;
    $(`.cart__item[data-vid="${curvid}"][data-key="${linekey}"]`).attr("data-estimateddaten", estimdate);
    return estimdate;
  }
  function updateMainProduct({
    origincountry,
    originCountryName,
    mindate,
    maxdate,
    eststr
  }) {
    const mindatestr = addBusinessDays(mindate);
    const maxdatestr = addBusinessDays(maxdate);
    $(".estimated-country-select").val(origincountry);
    $(".estimate-shipping-block").show();
    const $countryOpt = $(".estimated-country-select").find(`option[value="${origincountry}"]`);
    const ccountry = $countryOpt.html();
    const ccountryflag = $countryOpt.attr("data-flag");
    const imgstr = `<img src="${ccountryflag}">`;

    eststr = eststr.replace(/\{flag\}(?!\s*<br\s*\/?>)/i, "{flag}<br>");

    eststr = eststr.replace("{delivery_min}", mindatestr)
      .replace("{delivery_max}", maxdatestr)
      .replace("{country}", ccountry)
      .replace("{flag}", imgstr);

    $(".estimated-delivery-dates").html(eststr);
    $(".estimated-date-input").val(`${mindatestr} and ${maxdatestr}`);
  }

  // --- Event handlers ---
  function getOriginCountryData(countryCode) {
    let origincountry = countryCode;
    const $countrySelect = $(".estimated-country-select");
    if ($countrySelect.find(`option[value="${origincountry}"]`).length == 0) {
      origincountry = "REST";
    }
    const originCountryName = $countrySelect.find(`option[value="${origincountry}"]`).html()?.trim() || 'Rest Of The World';
    const originlocations = locationMap[origincountry] || "geo_AllCountry";
    const originLocationIds = locationIdsMap[originlocations] || [];
    return { origincountry, originCountryName, originlocations, originLocationIds };
  }

  // Product and grid estimations
  const handleGridProductDate = (curvid, data) => {
    const { mindate, maxdate } = findEstimateData({
      curvid,
      originLocationIds: data.originLocationIds,
      originCountryName: data.originCountryName
    }) || {};
    if (mindate && maxdate) updateGridProduct(curvid, mindate, maxdate);
  };

  $(window).on("fetchEstimatedDate", (event) => {
    const country = event.detail.country;
    const data = getOriginCountryData(country);
    
     
    // For product template page
    if ($("body").hasClass("template-product")) {
      const curvid = $(".estimated-country-select").attr("data-vid");
      const estimate = findEstimateData({
        curvid,
        originLocationIds: data.originLocationIds,
        originCountryName: data.originCountryName,
        isPersonalization: $("#personalization-form").hasClass("has-personalization")
      });
     
      if (estimate) updateMainProduct({ ...data, ...estimate });
    }

    // For grid items
    $(".grid__item__product").each(function () {
      let curvid = Number($(this).data("variant-id"));
      const $activeSwatch = $(this).find(".color-swatch.is-active");
      if ($activeSwatch.length > 0) curvid = $activeSwatch.attr("data-variant-id");
      handleGridProductDate(curvid, data);
    });

    // Trigger cart item estimation
    window.dispatchEvent(new CustomEvent("fetchCartItemEstimatedDate", {
      detail: { country: country }
    }));
  });

  $(window).on("fetchCartItemEstimatedDate", (event) => {
    const country = event.detail.country;
    var estkey = $('body').attr('data-estkey'); 
    const data = getOriginCountryData(country);
    $(".cart__items .cart__item").each(function () {
      const curvid = Number($(this).attr("data-vid"));
      const hasengraving = $(this).attr("data-hasengraving");
      const curestimated = $(this).attr("data-estimateddate");
      const linekey = $(this).attr("data-key");
      const estimate = findEstimateData({
        curvid,
        originLocationIds: data.originLocationIds,
        originCountryName: data.originCountryName,
        hasengraving
      });
      
      if (!estimate) return;
      const estimdate = updateCartItem(curvid, linekey, estimate.mindate, estimate.maxdate);
      
      // Only update cart if estimated date changed
      if (curestimated !== estimdate) {
        fetch("/cart.js").then(r => r.json()).then(cart => {
          const item = cart.items.find(i => i.key === linekey);
          if (item) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: linekey,
                properties: { ...item.properties, [estkey]: estimdate }
              })
            }).then(() => document.dispatchEvent(new Event("cart:build")));
          }
        });
      }
    });
  });

  // Other events (single, upsell, etc) can reuse main logic
  function triggerGridForEvent(event) {
    const country = event.detail.country;
    const data = getOriginCountryData(country);
    $(".grid__item__product").each(function () {
      const curvid = Number($(this).data("variant-id"));
      handleGridProductDate(curvid, data);
    });
  }
  $(window).on("fetchProductEstimatedDate", event => {
    const data = getOriginCountryData(event.detail.country);
    if ($("body").hasClass("template-product")) {
      const curvid = $(".estimated-country-select").attr("data-vid");
      const estimate = findEstimateData({
        curvid,
        originLocationIds: data.originLocationIds,
        originCountryName: data.originCountryName,
        isPersonalization: $("#personalization-form").hasClass("has-personalization")
      });
      if (estimate) updateMainProduct({ ...data, ...estimate });
    }
  });
  $(window).on("fetchSingleItemDate", event => {
    const data = getOriginCountryData(event.detail.country);
    const curvid = Number(event.detail.varid);
    
    handleGridProductDate(curvid, data);
  });
  $(window).on("fetchUpsellItemsDate", triggerGridForEvent);

  // --- Initialization and UI events ---
  // Initial estimation on load
  window.dispatchEvent(new CustomEvent("fetchEstimatedDate", {
    detail: { country: getCookie("country-origin") }
  }));

  // On country change
  $(".estimated-country-select").change(function () {
    window.dispatchEvent(new CustomEvent("fetchEstimatedDate", {
      detail: { country: $(this).val() }
    }));
  });

  // Personalization UI logic
  let countryname = $('.estimated-country-select').find(`option[value="${getCookie("country-origin")}"]`).html();
  if (!$('.estimated-country-select').find(`option[value="${getCookie("country-origin")}"]`).length) {
    countryname = 'Rest Of The World';
  }
  $('.hide-countries-wrapper .hide-countries').each(function() {
    if ($(this).html() == countryname) {
      $('.add-personisation-button').remove();
    }
  });
  
});
